import { render } from "./BookingDetails.vue?vue&type=template&id=573c8a52&scoped=true"
import script from "./BookingDetails.vue?vue&type=script&lang=js"
export * from "./BookingDetails.vue?vue&type=script&lang=js"

import "./BookingDetails.vue?vue&type=style&index=0&id=573c8a52&lang=scss&scoped=true"
import "./BookingDetails.vue?vue&type=style&index=1&id=573c8a52&scoped=true&lang=css"
import "./BookingDetails.vue?vue&type=style&index=2&id=573c8a52&lang=scss"
import "./BookingDetails.vue?vue&type=style&index=3&id=573c8a52&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-573c8a52"]])

export default __exports__